// Scroll any [data-ax-buy] link to the bundle picker (falls back to the product form),
// then move keyboard focus there so keyboard and screen-reader users land on it too.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-ax-buy]');
  if (!trigger) return;
  const target = document.querySelector('quantity-breaks') || document.querySelector('product-form');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const focusable = target.querySelector('input:checked, button');
  if (focusable) focusable.focus({ preventScroll: true });
});
